// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3bc0e7b9","453":"e417cd76","553":"2da318b0","977":"07e424dd"}[chunkId] + ".chunk.js";
};